module.exports = __webpack_public_path__ + "static/img/74.d59ed6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/74.png
// module id = pRlZ
// module chunks = 1